import { useState } from 'react';
import { Button, Alert, Card } from 'react-bootstrap';
import { API_ENDPOINTS } from '../config/api';

export default function ConnectionTest() {
  const [testResult, setTestResult] = useState('');
  const [loading, setLoading] = useState(false);

  const testConnection = async () => {
    setLoading(true);
    setTestResult('Testing connection...');

    try {
      // Test health check
      const healthResponse = await fetch(API_ENDPOINTS.PRODUCTS.ACTIVE.replace('/products/active', '/'));
      const healthData = await healthResponse.json();
      
      if (healthData.status === 'success') {
        setTestResult(`✅ Backend Connected! 
        Server: ${healthData.message}
        Environment: ${healthData.environment}
        Timestamp: ${healthData.timestamp}`);
      } else {
        setTestResult('❌ Backend health check failed');
      }
    } catch (error) {
      setTestResult(`❌ Connection failed: ${error.message}`);
    }
    
    setLoading(false);
  };

  const testProducts = async () => {
    setLoading(true);
    setTestResult('Testing products endpoint...');

    try {
      const response = await fetch(API_ENDPOINTS.PRODUCTS.ACTIVE);
      const data = await response.json();

      if (response.ok) {
        setTestResult(`✅ Products endpoint working! Found ${data.length} products
        Sample product: ${data[0]?.name || 'No products'}`);
      } else {
        setTestResult(`❌ Products endpoint failed: ${response.status}`);
      }
    } catch (error) {
      setTestResult(`❌ Products test failed: ${error.message}`);
    }

    setLoading(false);
  };

  const testDatabase = async () => {
    setLoading(true);
    setTestResult('Testing database connection...');

    try {
      const response = await fetch(API_ENDPOINTS.PRODUCTS.ACTIVE.replace('/products/test', '/db-test'));
      const data = await response.json();

      if (response.ok) {
        setTestResult(`Database Status: ${data.database}
        MongoDB URI: ${data.mongoUri}
        Message: ${data.message}`);
      } else {
        setTestResult(`❌ Database test failed: ${response.status}`);
      }
    } catch (error) {
      setTestResult(`❌ Database test failed: ${error.message}`);
    }

    setLoading(false);
  };

  return (
    <Card className="m-3">
      <Card.Header>
        <h5>🔧 Connection Test</h5>
      </Card.Header>
      <Card.Body>
        <p><strong>API Base URL:</strong> {API_ENDPOINTS.PRODUCTS.ACTIVE.replace('/products/active', '')}</p>
        
        <div className="d-flex gap-2 mb-3">
          <Button
            variant="primary"
            onClick={testConnection}
            disabled={loading}
          >
            Test Health Check
          </Button>
          <Button
            variant="secondary"
            onClick={testProducts}
            disabled={loading}
          >
            Test Products
          </Button>
          <Button
            variant="warning"
            onClick={testDatabase}
            disabled={loading}
          >
            Test Database
          </Button>
        </div>

        {testResult && (
          <Alert variant={testResult.includes('✅') ? 'success' : 'danger'}>
            <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>
              {testResult}
            </pre>
          </Alert>
        )}
      </Card.Body>
    </Card>
  );
}
